// ============================================================
// BOLD BRASILEIRO — Navegação por âncora
// 1. Clique em <a href="#anchor"> na própria home: smooth scroll
// 2. Chegada via URL com #anchor (vindo de outra página): smooth
//    scroll após o load, evitando o "pulo" nativo do browser
// 3. Offset do header fixo é considerado pra não cobrir o título
// ============================================================

(function () {
    'use strict';

    var MOBILE_MAX   = 767; // breakpoint medium
    var MOBILE_EXTRA = 24;  // respiro extra no celular — ver abaixo

    // O desconto só faz sentido quando o header cobre o conteúdo. No celular
    // ele rola junto (position: relative), e descontar a altura dele parava a
    // seção 192px abaixo do topo da tela — era o "desce só um pouco".
    function getHeaderHeight() {
        var head = document.querySelector('.site-head');
        if (!head) return 0;

        var pos = window.getComputedStyle(head).position;
        return (pos === 'fixed' || pos === 'sticky') ? head.offsetHeight + 12 : 0;
    }

    // Sem header pra descontar, a seção encostaria no topo da tela. No celular
    // ganha um respiro pra não colar, e o conteúdo entra mais alto.
    function getExtraOffset() {
        return window.innerWidth <= MOBILE_MAX ? MOBILE_EXTRA : 0;
    }

    function scrollToTarget(target) {
        if (!target) return;
        var top = target.getBoundingClientRect().top + window.pageYOffset
                - getHeaderHeight() + getExtraOffset();
        window.scrollTo({
            top: Math.max(top, 0),
            behavior: 'smooth'
        });
    }

    // 1. Smooth scroll quando o link aponta pra uma âncora da página atual
    document.addEventListener('click', function (e) {
        var link = e.target.closest('a[href*="#"]');
        if (!link) return;

        var url    = new URL(link.href, window.location.href);
        var hash   = url.hash;
        var same   = url.pathname === window.location.pathname && url.host === window.location.host;

        if (!hash || hash === '#' || !same) return;

        var target = document.querySelector(hash);
        if (!target) return;

        e.preventDefault();
        scrollToTarget(target);
        // Atualiza a URL sem disparar o scroll nativo do browser
        if (history.pushState) history.pushState(null, '', hash);
    });

    // 2. Chegou via URL com hash (vindo de outra página): scroll suave após o load
    window.addEventListener('load', function () {
        var hash = window.location.hash;
        if (!hash || hash === '#') return;

        var target = document.querySelector(hash);
        if (!target) return;

        // Sobe pro topo primeiro (anula o auto-scroll nativo), depois rola suave
        window.scrollTo(0, 0);
        setTimeout(function () {
            scrollToTarget(target);
        }, 80);
    });
})();
